export default __webpack_public_path__ + "static/Portrait-Light-Web-eb29993f30ddc588db4bdd8c86e6a4e9.woff2";